import React, { useState } from 'react';
import AdminSettings from './AdminSettings';
import ManageAccount from './ManageAccount';
import './AdminPage.css';

const SettingsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v2M12 20v2M2 12h2M20 12h2M5.64 5.64l1.42 1.42M16.94 16.94l1.42 1.42M5.64 18.36l1.42-1.42M16.94 7.06l1.42-1.42M18.36 5.64l-1.42 1.42M7.06 16.94l-1.42 1.42" />
  </svg>
);

const AccountIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const SECTIONS = [
  { id: 'settings', label: 'Settings', icon: SettingsIcon },
  { id: 'manage-account', label: 'Manage account', icon: AccountIcon },
];

function AdminPage({ section: controlledSection, onSectionChange }) {
  const [internalSection, setInternalSection] = useState('settings');
  const section = controlledSection ?? internalSection;
  const setSection = onSectionChange ?? setInternalSection;

  return (
    <div className="admin-page">
      <div className="admin-tabs">
        {SECTIONS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type="button"
            className={`admin-tab ${section === id ? 'active' : ''}`}
            onClick={() => setSection(id)}
          >
            <Icon />
            <span>{label}</span>
          </button>
        ))}
      </div>
      <div className="admin-content">
        {section === 'settings' && <AdminSettings />}
        {section === 'manage-account' && <ManageAccount />}
      </div>
    </div>
  );
}

export default AdminPage;
